module.exports = __webpack_public_path__ + "img/main_pt.fc61ac37.jpg";